import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Modal from "react-modal";
import axios from "axios";
import { useAlert } from "react-alert";

import { ValidationHelper } from "../../helpers";
import { FieldGroup, SubmitButton } from "..";

try {
  Modal.setAppElement("#app");
} catch (e) {
  console.error(e);
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    padding: "0",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
  },
};

const CreateEventModal = ({
  open,
  closeModal,
  afterSubmit = null,
  inviterDaoUserId,
  inviteeDaoUserId,
  onInviteGenerated,
}) => {
  const alert = useAlert();
  const [submitting, setSubmitting] = useState(false);

  const validationSchema = Yup.object({
    ...ValidationHelper.requiredRules(["name"]),
  });

  const onSubmit = async (data) => {
    setSubmitting(true);
    const response = await axios.post("/api/events", data);
    setSubmitting(false);
    if (afterSubmit) {
      afterSubmit(response.data);
      closeModal();
    }
  };

  const handleGenerateInvite = async () => {
    try {
      setSubmitting(true);
      const payload = {
        inviter_dao_user_id: inviterDaoUserId,
        invitee_dao_user_id: inviteeDaoUserId,
      };
      const { data } = await axios.post("/api/invite-codes", payload);
      if (onInviteGenerated) onInviteGenerated(data);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 422) {
        const errorMessage =
          err?.response?.data?.message ||
          "Please add a mobile number to generate invite code.";
        alert.show(errorMessage);
      } else {
        alert.show("Failed to generate invite code. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <Formik
        initialValues={{ name: "" }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form>
          <div className="content m-3">
            <p className="text-center">CREATE NEW EVENT</p>

            <FieldGroup placeholder="Event name" type="text" name="name" />
            <FieldGroup
              placeholder="External Event ID"
              type="text"
              name="external_event_id"
            />
          </div>

          <div className="d-flex justify-content-center gap-2 mb-3">
            <SubmitButton isSubmitting={submitting} label="Add to list" />

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleGenerateInvite}
              disabled={submitting || !inviterDaoUserId || !inviteeDaoUserId}
            >
              GENERATE INVITE CODE
            </button>
          </div>
        </Form>
      </Formik>
    </Modal>
  );
};

export default CreateEventModal;
